export default __webpack_public_path__ + "static/media/6.64ea216c.jpg";